import {encodeAsJsonUriParams} from "@/router/routeParamsHelper";

const getters = {
    loading(state) {
        return state.loading;
    },
    isBusinessUnitPanelVisible(state) {
        return state.isBusinessUnitPanelVisible;
    },
    isDateTimePanelVisible(state) {
        return state.isDateTimePanelVisible;
    },
    dateTabItem(state) {
        return state.dateTabItem;
    },
    isFiltersPanelVisible(state) {
        return state.isFiltersPanelVisible;
    },
    alias(state) {
        return state.alias;
    },
    isDirtySearch(state) {
       return state.isDirtySearch;
    },
    filters(state) {
        return state.filters;
    },
    enabledFilters(state) {
      return state.filters.filter(filter => filter.isEnabled);
    },
    searchQueryStr(state) {
        return state.searchQueryStr;
    },
    searchQuery(state) {
        if(!state.searchQueryStr) {
            return [];
        }

        const criteriaSplitter = /(<=|>=|!=|=|<|>)/;

        let searchQuery = state.searchQueryStr
            .split(" ")
            // Hack to to detect and optimize search by transactionID
            .map(criteria => {
                const transactionIdRegexp = RegExp('^([0-9]*-){5}[0-9]*$');
                return transactionIdRegexp.test(criteria) ? `transaction.transactionID=${criteria}` : criteria;
            })
            .map(criteria => {
                if(criteriaSplitter.test(criteria)) {
                    const splitted = criteria.split(criteriaSplitter);
                    return {
                        label : splitted[0],
                        operator : splitted[1],
                        value : splitted[2]
                    }
                } else {
                    return {
                        label : "search",
                        operator : "=",
                        value : criteria
                    }
                }
            });

        return searchQuery;
    },
    // Date
    ignoreDate(state, getters) {
      return state.filters.find(filter => filter.label == 'transactionID' && filter.isEnabled) ||
             getters.searchQuery.find(query => query.label == 'transaction.transactionID');
    },
    beginDate(state) {
        return state.beginDate;
    },
    endDate(state) {
        return state.endDate;
    },
    // Poslog
    poslogsTableOptions(state) {
        return state.poslogsTableOptions;
    },
    nbMaxPoslogs(state) {
        return state.nbMaxPoslogs;
    },
    poslogs(state) {
        return state.poslogs;
    },
    shareUrlParam(state) {
        return encodeAsJsonUriParams(
            {
                searchQueryStr: state.searchQueryStr,
                filters: state.filters,
                beginDate: state.beginDate,
                endDate: state.endDate,
                poslogsTableOptions: state.poslogsTableOptions
            }
        );
    }
};

export default getters;
